<script>
export let showMenu;
export let hideMenuItems;
export let updateData;
export let menuGames;
export let formatDateTime;
export let formatCurrencySEK;
export let drawNumber;
</script>

{#if showMenu === true}
      <button class="hamburger" class:open={!hideMenuItems} on:click={() => hideMenuItems = !hideMenuItems} aria-label="Menu">
  <svg width="30" height="30" viewBox="0 0 100 100">
    <rect class="line top" width="80" height="10" x="10" y="25" rx="5"/>
    <rect class="line middle" width="80" height="10" x="10" y="45" rx="5"/>
    <rect class="line bottom" width="80" height="10" x="10" y="65" rx="5"/>
  </svg>
      </button>

<!-- <button class="menuButton" on:click={() => hideMenuItems = !hideMenuItems}>Menu</button> -->
{/if}

<div class="menu" class:hiddenMenu={hideMenuItems}>

<!--       <p>
        <button 
            on:click={() => updateData("stryktipset")} 
            on:click={() => hideMenuItems = !hideMenuItems}
            class="stryktipset">
            <img src="images/stryktipset.svg" alt="Stryktipset" height="24pt" />
        </button>
      </p>

      <p>
        <button 
            on:click={() => updateData("europatipset")} 
            on:click={() => hideMenuItems = !hideMenuItems} 
            class="europatipset">
          <img src="images/europatipset.svg" alt="Europatipset" height="24pt" />
        </button>
      </p>

      <p>
        <button 
            on:click={() => updateData("topptipset")} 
            on:click={() => hideMenuItems = !hideMenuItems}
            class="topptipset">
          <img src="images/topptipset.svg" alt="Topptipset" height="24pt" />
        </button>
      </p> -->

{#if menuGames}

      {#each menuGames as item}
      {#if parseInt(drawNumber) !== parseInt(item.drawNumber)}
      <div class="menuRow">
        <button 
            on:click={() => updateData(item.productName.toLowerCase(),item.drawNumber)} 
            on:click={() => hideMenuItems = !hideMenuItems}
            class="{item.productName.toLowerCase()}">
                  <img src="images/{item.productName.toLowerCase()}.svg" alt="{item.productName}" height="24pt" />
                  <br />
                        <img src="/images/alarmclock.svg" height="18pt" alt="Spelstopp" title="Spelstopp" /> {formatDateTime(item.closeTime)}
                        <!-- <img src="/images/moneybag.svg" style="padding-left: 10pt;" height="18pt" alt="Omsättning" title="Omsättning" /> {formatCurrencySEK(parseInt(item.turnover.replace(",", ".")))} -->
                        <img src="/images/moneybag.svg" style="padding-left: 10pt;" height="18pt" alt="Omsättning" title="Omsättning" /> {formatCurrencySEK(parseInt(item.turnover))}
                        {#if item.jackpotItems !== 0}
                              + <img src="/images/jackpot.svg" height="18pt" alt="Jackpot" title="Jackpot" /> {formatCurrencySEK(item.jackpotItems)}
                        {/if}
        </button>
      </div>
      {/if}
      {/each}
{/if}


</div>

<style>

img {
  vertical-align: text-top;
/*   padding-left: 10pt; */
}


.hamburger {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      position: fixed;
      cursor: pointer;
      top: 10px;
      right: 20px;
      z-index: 20;
}

  .line {
    fill: var(--themeColorText);
    transition: transform 300ms ease-in, opacity 0ms 200ms;
    transform-origin: center;
  }

  .open .line {
    transition: transform 300ms ease-in, opacity 0ms 100ms;
  }

  .open .top {
    transform: translate(0, 15px) rotate(-45deg);
  }

  .open .middle {
    opacity: 0;
  }

      .open .bottom {
            transform: translate(0, -14px) rotate(45deg);
      }

      .menu {
            display: flex;
            flex-direction: column;
            text-align: center;
            height: 100%;
            background-color: var(--themeColor1);
            padding: 10px;
            border-top: 2px solid whitesmoke;
            position: absolute;
            width: 100%;
            top: 55pt;
            right: 0;
            z-index: 1000;
            visibility: visible;
            opacity: 1;
            transition: opacity 0.3s, visibility 0.3s, transform 0.2s ease;
            transform: translateY(0%);
            overflow-y: scroll;
            padding-bottom: 60pt;
      }

      .hiddenMenu {
            opacity: 0;
            visibility: hidden;
            transform: translateY(10%);
      }

.menuRow {
      flex: 1;
      text-align: center;
}

 .menu button {
    margin-top: 5px;
    padding: 5pt 0 0pt 0;
    line-height: 35px;
    width: 95%;
    max-width: 450px;
    background-color: var(--themeColor1, #008733);
    color: white;
    border: 2pt solid white;
    border-radius: 5px;
    cursor: pointer;
  }

</style>